<template>
  <div v-if="actions.length" class="widget-title-actions">
    <slot name="prepend"></slot>
    <v-list
      nav
      class="w-100"
      color="var(--ui-accent-primary)"
      density="compact"
      :lines="false"
    >
      <v-list-item
        v-for="(item, idx) in displayItems"
        :key="item.title + '-' + idx"
        @click="handleItemClick(item, idx)"
        color="var(--ui-accent-primary)"
        :title="replaceFieldFromDetailPage('title', item.title)"
      >
        <template v-if="item.icon" v-slot:prepend>
          <ui-icon :name="item.icon" :size="18" />
        </template>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  import { useAppStore } from "@/stores/appStore";
  import actionsMixin from "@/mixins/actionsMixin";
  import wh from "@/helpers/widgetsHelpers.js";
  import { parseJsonField } from "@/util/parseJson";

  export default {
    mixins: [actionsMixin],
    props: {
      actions: { type: Array, default: () => [] },
      data: { type: Object, default: () => ({}) },
      slice: { type: Number, default: 2 }, // na hoeveel knoppen overflow start
      menuOnly: { type: Boolean, default: false }, // als true: geen losse knoppen, alles in menu
      btn_variant: { type: String, default: "flat" },
      btnBlock: { type: Boolean, default: false },
      collection_id: { type: Number }, // collection data voor context
    },
    data() {
      return {
        loading: false,
        loadingIndex: null,
      };
    },
    computed: {
      // kies de items die je direct als knoppen toont
      displayItems() {
        return this.menuOnly ? [] : this.actions.slice(0, this.slice);
      },
      // kies de items die in het menu terechtkomen
      overflowItems() {
        return this.menuOnly ? this.actions : this.actions.slice(this.slice);
      },
      appStore() {
        return useAppStore();
      },

      rawCollectionId() {
        const c = this.data?.collection?.collection;
        if (c) {
          // andere types
          return c;
        }
      },
    },
    methods: {
      replaceFieldFromDetailPage(type, template) {
        return wh.replaceFieldFromDetailPage(type, template);
      },

      async handleItemClick(item) {
        // bepaal collectionId via fallback-keten
        const collectionId = this.collection_id;
        if (!collectionId) {
          console.warn("Geen collection_id beschikbaar voor actionItemClicked");
          this.$toast.error("Kan item niet openen – collectie onbekend.");
          return;
        }

        console.log("handleItemClick called with item:", item);

        const configs = this.data?.data?.item_click_actions || [];
        if (!configs.length) {
        }
        const config = configs[0];
        const actionType = config?.action?.type;
        if (!actionType) return;

        const payload = {
          collection_id: collectionId,
          page_title: this.replaceFieldToData(item, "title"),
          ...item,
          action: config,
          widget: {
            ...this.data,
            collection: parseJsonField(this.data.collection),
          },
        };

        console.log("action delete called with payload:", payload);
        console.log("actionType:", actionType);

        try {
          await this.actionsTrigger(actionType, payload);
        } catch (err) {
          console.error("Error executing ItemClickAction:", err);
        }
      },

      // async handleItemClick(item, index) {
      //     const actionType = item?.action?.type;
      //     if (!actionType) return;

      //     this.loadingIndex = index;
      //     const formdata = {
      //         ...this.data,
      //         collection: parseJsonField(this.appStore.active.page.collection),
      //     };

      //     try {
      //         await this.actionsTrigger(actionType, { ...item, data: formdata });
      //     } catch (err) {
      //         console.error("Error executing action:", err);
      //     } finally {
      //         this.loadingIndex = null;
      //     }
      // },
    },
  };
</script>

<style>
  .widget-title-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
</style>
